<template>
  <span>
    <select v-if="displayType === 'form'" name="" class="form-control" v-bind:value="modelValue" v-on:change="onChange($event.target.value)">
      <slot></slot>
      <template v-for="race in raceList"><option  v-if="gender === '' || race.gender === gender" :value="race.raceCode" :selected="race.raceCode == defaultRace">
        {{race.description}}
      </option></template>
    </select>
    <span v-if="displayType === 'label'">{{raceLabel}}</span>
  </span>
</template>

<script>
  import CommonDataService from '../endpoints/CommonDataService'
  export default {
    emits: ['update:modelValue','change'],
    name: 'race-input',

    props: ['modelValue', 'displayType', 'gender'],
    data () {
      return {
        raceList: []
      }
    },
    computed: {
      defaultRace () {
        return this.modelValue
      },
      raceLabel: function () {
        if (this.raceList && this.raceList.length > 0) {
          let race = this.raceList.find((el) => el.raceCode === this.modelValue)
          if (race) return race.description
        }

        return ''
      }
    },
    methods: {
      loadRaceList: function () {
        let self = this
        if (sessionStorage.raceList && sessionStorage.raceList.length > 0) {
          self.raceList = JSON.parse(sessionStorage.raceList)
          return
        }

        CommonDataService.loadRaceList()
          .then(response => {
            self.raceList = response.data
            sessionStorage.raceList = JSON.stringify(self.raceList)
          })
          .catch(error => {
            self.error = error.message
          })
      },
      onChange (value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    },
    created () {
      this.loadRaceList()
    }
  }
</script>
